// Form state types for alert rule management

import { AlertRuleProperty, AlertRuleTag, AlertRuleThreshold } from './AlertRules';

// Form data interface
export interface AlertRuleFormData {
    id: string;
    name: string;
    entitytype: string;
    metrictype: string;
    intervalminutes: number;
    evaluationwindowminutes: number;
    units: string;
    decreasing: string;
    disabled: boolean;
    statistic: string;
    aggregation: string;
    thresholdarray: AlertRuleThreshold[];
    properties: AlertRuleProperty[];
    host: number[];
    datasource: number[];
    tag: AlertRuleTag[];
    disk: string[];
    anyhost: boolean;
    anydatasource: boolean;
    anydisk: boolean;
    availabilitygroup?: string[];
    anyavailabilitygroup?: boolean;
    database?: string[];
    anydatabase?: boolean;
}

// Form validation state
export interface AlertRuleFormValidation {
    name: {
        isValid: boolean;
        isUsed: boolean;
        className: string;
    };
    thresholdarray: {
        isValid: boolean;
        message?: string;
    };
    evaluationwindow: {
        isValid: boolean;
        message?: string;
    };
    statistic: {
        isValid: boolean;
        hasError: boolean;
    };
    isFormValid: boolean;
}

// Form UI state
export interface AlertRuleFormUIState {
    isMissing: boolean;
    isError: boolean;
    disabled: boolean;
    loading: boolean;
}

// Form dependencies data
export interface AlertRuleFormDependencies {
    // Can add dependencies like available metrics, hosts, instances etc.
}

// Complete form state
export interface AlertRuleFormState {
    formData: AlertRuleFormData;
    validation: AlertRuleFormValidation;
    uiState: AlertRuleFormUIState;
    dependencies: AlertRuleFormDependencies;
}

export const EVALUATION_WINDOW_MAX = 60;
export const FREQUENCY_MAX = 1440;

// Default values
export const createDefaultFormData = (): AlertRuleFormData => ({
    id: '',
    name: '',
    entitytype: 'host',
    metrictype: 'statistic',
    intervalminutes: 1,
    evaluationwindowminutes: 1,
    units: '%',
    decreasing: 'false',
    disabled: false,
    statistic: 'cpuutilisation',
    aggregation: 'avg',
    thresholdarray: [
        { threshold: NaN, severity: 1 },
        { threshold: NaN, severity: 2 },
        { threshold: NaN, severity: 3 }
    ],
    properties: [],
    host: [],
    datasource: [],
    tag: [],
    disk: [],
    anyhost: true,
    anydatasource: true,
    anydisk: true,
    availabilitygroup: [],
    anyavailabilitygroup: true,
    database: [],
    anydatabase: true
});

export const createDefaultValidation = (): AlertRuleFormValidation => ({
    name: {
        isValid: true,
        isUsed: false,
        className: ''
    },
    thresholdarray: {
        isValid: true,
        message: undefined
    },
    evaluationwindow: {
        isValid: true,
        message: undefined
    },
    statistic: {
        isValid: true,
        hasError: false
    },
    isFormValid: true
});

export const createDefaultUIState = (disabled: boolean = false): AlertRuleFormUIState => ({
    isMissing: false,
    isError: false,
    disabled,
    loading: false
});

export const createDefaultDependencies = (): AlertRuleFormDependencies => ({
    // Empty for now
});
